import React, { useEffect, useState, useContext } from "react"
import styled from "styled-components"
import { Carousel } from "antd"
import moment from 'moment'
import { isEmpty, get, filter } from "lodash"

import { FormNavigationContext } from "../../../Panes/Form"
import ResultOptionPanel from "./ResultOptionPanel"
import Link from "../../../../Sections/New/NewLink"
import { Button } from "../NavigationButton"
import withQueryString from '../../../../highOrderComponents/withQueryString'

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  > * {
    &:not(:first-child) {
      margin-left: 14px;
    }
  }
`

const ButtonDiv = styled.div`
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 12px;
`

const CarouselWrapper = styled.div`
  display: block;
  width: 600px;
  height: 100%;
  margin: 12px auto;

  .ant-carousel .slick-dots li.slick-active button {
    color: black !important;
    background: black !important;
    width: 20px;
    height: 20px;
    border-radius: 40px;
  }
  .ant-carousel .slick-dots li button {
    color: black !important;
    background: black !important;
    width: 20px;
    height: 20px;
    border-radius: 40px;
  }
`

const ResultOptionPanels = ({ resultOptions, queryString, ...props }) => {
  const context = useContext(FormNavigationContext)
  const [width, setWidth] = useState(0)
  const [selected, setSelected] = useState(resultOptions[0])
  useEffect(() => {
    const newWidth = checkWidth()
    setWidth(newWidth)
  }, [])


  const checkWidth = () => {
    const body = document.body
    const html = document.documentElement
    const width = Math.max(
      body.scrollWidth,
      body.offsetWidth,
      html.clientWidth,
      html.scrollWidth,
      html.offsetWidth
    )
    return width
  }

  const pickOption = panel => {
    setSelected(panel)
    context.result[context.activeIdentifier] = panel
  }

  let passedState = {}
  if (!isEmpty(get(selected, 'state.code', ''))) {
    const variables = selected.state.code.split(',')
    variables.map((variable) => {
      passedState[variable] = context.result[variable]
    })
    for (const key in passedState) {
      if (passedState[key] === undefined) {
        delete passedState[key]
      } else if (moment.isMoment(passedState[key])) {
        passedState[key] = moment(passedState[key]).toISOString()
      }
    }
  }

  return (
    <>
      {width > 1070 && resultOptions.length <= 3 ? (
        <OptionsWrapper>
          {resultOptions.map((panel, index) => {
            const color = index % 2 === 0 ? "beige" : "grey"
            return (
              <ResultOptionPanel
                key={panel.headline}
                panel={panel}
                color={color}
                clickAction={() => pickOption(panel)}
                selected={selected === panel}
              />
            )
          })}
        </OptionsWrapper>
      ) : (
        <CarouselWrapper>
          <Carousel
            dotsClass={{
              color: "black",
              background: "black",
              borderRadius: "60px",
              width: "90px",
              height: "20px",
            }}
            dotPosition="right"
          >
            {resultOptions.map((panel, index) => {
              const color = index % 2 === 0 ? "beige" : "grey"
              return (
                <ResultOptionPanel
                  key={panel.headline}
                  carousel={true}
                  panel={panel}
                  color={color}
                  selected={selected === panel}
                  clickAction={() => pickOption(panel)}
                />
              )
            })}
          </Carousel>
        </CarouselWrapper>
      )}
      <ButtonDiv>
        {(selected.internalLink || selected.externalLink) ? <Link internalLink={selected.internalLink} externalLink={selected.externalLink}  state={{ ...passedState, meta: queryString }}>
          <Button
            dark={false}
            disabled={isEmpty(selected)}
          >Auswählen</Button>
        </Link> : <Button disabled={isEmpty(selected)} onClick={() => context.goToIdentifier(selected.identifierTo)}>Auswählen</Button>}
      </ButtonDiv>
    </>
  )
}

export default withQueryString(ResultOptionPanels)
